import axios from 'axios'

class CartApi {
  constructor (client) {
    this.client = client
    this.updateControllers = new Map()
  }

  async updateAmount (formData) {
    const article = formData.get('article')
    const amount = Number(formData.get('amount'))
    if (!Number.isFinite(amount) || amount < 0) {
      return
    }

    if (this.updateControllers.has(article)) {
      this.updateControllers.get(article).abort()
    }

    const controller = new AbortController()
    this.updateControllers.set(article, controller)

    try {
      const { data } = await this.client.post(
        '/api/cart/update_amount/',
        formData,
        { signal: controller.signal },
      )

      this.updateControllers.delete(article)
      return data
    } catch (err) {
      if (err.name === 'CanceledError') {
        return
      }
      throw err
    }
  }

  deleteCart (formData) {
    return this.client
      .post(`/api/cart/delete/`, formData)
      .then(response => response.data)
  }

  products () {
    const page = window.location.pathname
    return this.client.get(`/api/cart/`, { params: { page } }).then(response => response.data)
  }

  move (formData) {
    return this.client
      .post(`/cart/move/`, formData)
      .then(response => response.data)
  }

  createOrder (selectedArticles = []) {
    return this.client.post(`/order/`, {
      selectedArticles,
    }).then(response => response.data)
  }
}

const cartApi = new CartApi(axios)

const apiUpdateAmount = formData => cartApi.updateAmount(formData)
const apiDeleteCart = formData => cartApi.deleteCart(formData)
const apiProducts = () => cartApi.products()
const apiMove = formData => cartApi.move(formData)
const createOrder = selectedArticles => cartApi.createOrder(selectedArticles)

export {
  apiUpdateAmount,
  apiDeleteCart,
  apiProducts,
  apiMove,
  createOrder,
}

export default cartApi
